import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { ButtonGroup, Button } from '@mui/material'

import { AppContext } from '/providers/app-context'

const Menu = () => {

  const navigate = useNavigate()
  const { client } = useContext(AppContext)

  const page = location.pathname.split("/").pop()

  return (
    <div className='flex flex-row justify-between'>
      <div />
      <ButtonGroup variant="text" aria-label="Actions">
        <Button onClick={() => navigate("../invoices")} sx={{color:page === "invoices" ? "link" : "text.secondary"}}>Invoices</Button>
        <Button onClick={() => navigate("../plan")} sx={{color:page === "plan" ? "link" : "text.secondary"}}>Subscription Plan</Button>
        {client.billing_mode === "prepay" && <Button onClick={() => navigate("../payment-card")} sx={{color:page === "payment-card" ? "link" : "text.secondary"}}>Payment Card</Button>}
        {client.billing_mode === "postpay" && <Button onClick={() => navigate("../direct-debit")} sx={{color:page === "direct-debit" ? "link" : "text.secondary"}}>Direct Debit Mandate</Button>}
      </ButtonGroup>
    </div>

  )
}

export default Menu